import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")

// JavaScript to toggle mobile menu
const menuToggle = document.getElementById('menu-toggle');
const mobileMenu = document.getElementById('mobile-menu');
menuToggle.addEventListener('click', () => {
  mobileMenu.classList.toggle('hidden');
});

const letters = "ABCDEFGHIJKLMNOPQRSTUVWXUZ ˁ˚ᴥ˚ˀ";

const matrixEffectCall = (event) => {
  let iterations = 0;
  const interval = setInterval(() => {
    event.target.innerText = event.target.innerText.split("")
                                  .map((letter, index) => {

                                    if (index < iterations) {
                                      return event.target.dataset.value[index];
                                    }

                                    return letters[Math.floor(Math.random() * 26)]

                                  })
                                  .join("");

    if (iterations >= event.target.dataset.value.length) clearInterval(interval);
    iterations += 1 / 3;
  }, 50);
}

const matrixEffect = (selector) => {

  document.querySelector(selector).onmouseover = event => {
    matrixEffectCall(event);
  }

}

if (document.location.pathname == '/') {
  matrixEffect('.cwd-logo');
  matrixEffect('.cwd-title');
}
